export default "__VITE_ASSET__WO78km4x__"